import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import AdminLeaveService from './AdminLeaveService';

const useManageAdminLeaves = () => {
  const [leaves, setLeaves] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const refreshLeaves = async (params = {}) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await AdminLeaveService.getAdminLeaves(params);
      setLeaves(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to load leave records';
      setError(errorMessage);
      toast.error(errorMessage);
      setLeaves([]);
    } finally {
      setIsLoading(false);
    }
  };

  const addLeave = async (leaveData) => {
    try {
      const response = await AdminLeaveService.addAdminLeave(leaveData);
      toast.success('Leave record added successfully');
      await refreshLeaves();
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to add leave record';
      toast.error(errorMessage);
      throw err;
    }
  };

  const editLeave = async (id, leaveData) => {
    try {
      const response = await AdminLeaveService.editAdminLeave(id, leaveData);
      toast.success('Leave record updated successfully');
      await refreshLeaves();
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to update leave record';
      toast.error(errorMessage);
      throw err;
    }
  };

  const deleteLeave = async (id) => {
    try {
      await AdminLeaveService.deleteAdminLeave(id);
      toast.success('Leave record deleted successfully');
      await refreshLeaves();
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to delete leave record';
      toast.error(errorMessage);
      throw err;
    }
  };

  return {
    leaves,
    isLoading,
    error,
    refreshLeaves,
    addLeave,
    editLeave,
    deleteLeave
  };
};

export default useManageAdminLeaves;

